import About from "./component/About/About";
import Contact from "./component/Contact/Contact";
import Home from "./component/Home/Home";
import Navbar from "./component/Navbar/Navbar";
import Portfolio from "./component/Portfolio/Portfolio";

function App () {
  return (
    <>
      <Navbar />
      <main>
        <Home />
        <About />
        <Portfolio />
        <Contact/>
      </main>
    </>
   
  );
}

export default App;
